class FitTitleIconWord {
    constructor() {
        this.DOM = {
            titles: document.querySelectorAll('.js-fit-title-word')
        };

        if (this.DOM.titles.length < 1) {
            return; // No elements to process
        }

        this.observer = new ResizeObserver(() => {
            this.setFitTitle();
        });

        this.DOM.titles.forEach((title) => {
            this.observer.observe(title.parentElement);
        });

        this.setFitTitle();

        window.addEventListener('load', () => {
            this.setFitTitle();
        });
    }

    setFitTitle() {
        const isMobile = window.matchMedia('(max-width: 1020px)').matches;

        this.DOM.titles.forEach((title) => {
            if (!isMobile) {
                // Let the regular fluid-type CSS handle sizing again
                title.style.fontSize = '';
                return;
            }

            // Let the CSS-driven font-size apply before measuring
            title.style.fontSize = '';

            const parent = title.parentElement;
            const parentStyle = getComputedStyle(parent);
            const parentWidth =
                parent.getBoundingClientRect().width -
                parseFloat(parentStyle.paddingLeft) -
                parseFloat(parentStyle.paddingRight);

            const baseFontSize = parseFloat(getComputedStyle(title).fontSize);

            // Create a measurement clone
            const measure = title.cloneNode(true);

            measure.style.position = 'absolute';
            measure.style.visibility = 'hidden';
            measure.style.pointerEvents = 'none';
            measure.style.width = 'max-content';
            measure.style.whiteSpace = 'nowrap';
            measure.style.fontSize = `${baseFontSize}px`;

            document.body.appendChild(measure);

            // Find the longest word across all title lines
            const words = title.textContent.trim().split(/\s+/);

            const wordWidth = Math.max(
                ...words.map((word) => {
                    measure.textContent = word;
                    return measure.getBoundingClientRect().width;
                })
            );

            measure.remove();

            // Only shrink the font-size when that word doesn't fit
            if (wordWidth > parentWidth) {
                title.style.fontSize = `${baseFontSize * (parentWidth / wordWidth)}px`;
            }
        });
    }
}

new FitTitleIconWord();
